export const getResetStatus = (state) => state.resetPasswordReducer.resetPasswordStatus;
export const getCheckTokenStatus = (state) => state.resetPasswordReducer.checkTokenPasswordResetStatus;
export const getChangePasswordStatus = (state) => state.resetPasswordReducer.changePasswordStatus;
